import {
  getMediaBasePath,
  IconWrapper,
  ImageWrapper,
  pxToRem,
  pxTovW,
  resourceTypeName,
} from '@geneo2-web/shared-ui';
import { Box, Typography } from '@mui/material';
import { useGlobalContext } from 'apps/student/src/app/Context/GlobalContextProvider';
import { Resource_ResourceEnum, ResourceCategoryEnum } from '@protos/content_management/content.db_pb';
import { ResourceContent as ResourceInfo } from '@protos/content_management/content.common.apis_pb';

interface IPalResourceHeading {
  resourceInfo?: ResourceInfo;
}

interface IIconTextBox {
  iconName: string;
  text?: string;
  index: number;
}

const IconTextBox = ({ iconName, text, index }: IIconTextBox) => {
  const { isIpadOnly } = useGlobalContext();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: pxToRem(4), md: pxTovW(4) },
        alignItems: 'center',
      }}
    >
      <IconWrapper
        name={iconName}
        size={isIpadOnly ? 'large' : 'md'}
        parentFolder="icons"
        type="png"
      />
      <Typography
        variant="elementSmallText"
        fontWeight={'bold'}
        color={index % 2 === 0 ? 'primary' : 'secondary'}
      >
        {text}
      </Typography>
    </Box>
  );
};

export const PalResourceHeading = ({ resourceInfo }: IPalResourceHeading) => {
  if (!resourceInfo) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '10px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: { xs: pxToRem(10), md: pxTovW(20) },
        }}
      >
        <ImageWrapper
          name="chapterImage"
          type="png"
          styles={{
            width: { xs: pxToRem(35), md: pxToRem(90) },
            height: { xs: pxToRem(35), md: pxToRem(90) },
            borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
            objectFit: 'cover',
          }}
          parentFolder="tempAssets"
          path={getMediaBasePath(
            resourceInfo.posterImageUrl,
            resourceInfo.resourceCategory ===
              ResourceCategoryEnum.RESOURCE_CATEGORY_MY_RESOURCES
              ? 'userDataBucket'
              : 'processedMediaBucket'
          )}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(10),
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="elementH3"
            sx={{
              wordWrap: 'break-word',
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {resourceInfo.title || ''}
          </Typography>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              gap: '15px',
              alignItems: 'center',
              mt: '5px',
            }}
          >
            {[
              {
                iconName: 'clock',
                text: (resourceInfo.estimatedTimeInMin || 0) + 'Mins',
              },
              {
                iconName: resourceTypeName(
                  resourceInfo.resourceType ||
                    Resource_ResourceEnum.RESOURCE_TYPE_UNDEFINED
                )?.icon,
                text: resourceTypeName(
                  resourceInfo.resourceType ||
                    Resource_ResourceEnum.RESOURCE_TYPE_UNDEFINED
                )?.name,
              },
            ].map((elem, index) => (
              <IconTextBox
                key={index}
                iconName={elem.iconName}
                text={elem.text}
                index={index}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
